
import { SlackIntegration } from "../types";
import { useSettingsState, useSettingsHandlers } from "./settings";

export const useSlackSettings = (aiStaffId: string = "1") => {
  const {
    webhookUrl,
    setWebhookUrl,
    slackToken,
    setSlackToken,
    triggerTag,
    setTriggerTag,
    isFileProcessingEnabled,
    setIsFileProcessingEnabled,
    isAutoResponsesEnabled,
    setIsAutoResponsesEnabled,
    isRoleDetectionEnabled,
    setIsRoleDetectionEnabled
  } = useSettingsState();

  const {
    handleTagChange: baseHandleTagChange,
    handleFileProcessingChange: baseHandleFileProcessingChange,
    handleAutoResponsesChange: baseHandleAutoResponsesChange,
    handleRoleDetectionChange: baseHandleRoleDetectionChange,
    updateSettingsWithFeedback
  } = useSettingsHandlers();

  const handleTagChange = (value: string, updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>) => {
    baseHandleTagChange(value, setTriggerTag, updateSettings);
  };
  
  const handleFileProcessingChange = (checked: boolean, updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>) => {
    baseHandleFileProcessingChange(checked, setIsFileProcessingEnabled, updateSettings);
  };
  
  const handleAutoResponsesChange = (checked: boolean, updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>) => {
    baseHandleAutoResponsesChange(checked, setIsAutoResponsesEnabled, updateSettings);
  };
  
  const handleRoleDetectionChange = (checked: boolean, updateSettings?: (settings: Partial<SlackIntegration>) => Promise<void>) => {
    baseHandleRoleDetectionChange(checked, setIsRoleDetectionEnabled, updateSettings);
  };

  const updateSettings = async (settings: Partial<SlackIntegration>, saveSettings: (settings: Partial<SlackIntegration>) => Promise<void>) => {
    return updateSettingsWithFeedback(settings, saveSettings);
  };

  return {
    webhookUrl,
    setWebhookUrl,
    slackToken,
    setSlackToken,
    triggerTag,
    setTriggerTag,
    isFileProcessingEnabled,
    setIsFileProcessingEnabled,
    isAutoResponsesEnabled,
    setIsAutoResponsesEnabled,
    isRoleDetectionEnabled,
    setIsRoleDetectionEnabled,
    handleTagChange,
    handleFileProcessingChange,
    handleAutoResponsesChange,
    handleRoleDetectionChange,
    updateSettings
  };
};
